import axios from "axios";
import { config, getDomain, tempAlErr, tempAlWait } from "../helpers";
import { CODE_FOLD_DEL, CODE_FOLD_DET, CODE_FOLD_LIST, CODE_FOLD_SAVE } from "./action-types";
import { alertIndex } from "../helpers/alertIndex";

// Liste des dossiers
export function getCodeFolders({idProject}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let url = `${getDomain()}api/code/folders-list/${idProject}`;
        let datas = [];

        axios.post(url, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred')
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (alert.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: CODE_FOLD_LIST,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("cofoli004");
                dispatch({
                    type: CODE_FOLD_LIST,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Détail d'un dossier
export function getCodeFolder({idFolder}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let url = `${getDomain()}api/code/folder/${idFolder}`;
        let datas = null;

        axios.post(url, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred')
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (alert.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: CODE_FOLD_DET,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("cofodt004");
                dispatch({
                    type: CODE_FOLD_DET,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Sauvegarde d'un dossier
export function getCodeFolderSave({
    idFolder = null,
    idFolderAdult,
    idProject,
    name
}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let url = `${getDomain()}api/code/folders/save`;
        if (idFolder != null) {
            url += `/${idFolder}`;
        }
        let isNext = false;

        axios.post(url, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred'),
            name: name,
            idFolderAdult: idFolderAdult,
            idProject: idProject
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (alert.type == "succ") {
                    isNext = true;
                }

                dispatch({
                    type: CODE_FOLD_SAVE,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("cofosa004");
                dispatch({
                    type: CODE_FOLD_SAVE,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
    }
}

// Supprimer un dossier
export function getCodeFolderDelete({
    idFolder
}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let url = `${getDomain()}api/code/folders/delete/${idFolder}`;
        let isNext = false;

        axios.post(url, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred'),
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (alert.type == "succ") {
                    isNext = true;
                }

                dispatch({
                    type: CODE_FOLD_DEL,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("cofodl004");
                dispatch({
                    type: CODE_FOLD_DEL,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
    }
}